jQuery(document).foundation();
var $ = jQuery;

$(document).ready(function () {
  $('#bewertungen-slider').slick({
    slidesToShow: 1,
    mobileFirst: true,
    autoplay: false,
    dots: false,
    adaptiveHeight: true,
    responsive: [
    {
      breakpoint: 1081,
      settings: {
        slidesToShow: 1,
      },
    },
  ]
  });
  $('#boxes-bar').slick({
    slidesToShow: 1,
    mobileFirst: true,
    autoplay: true,
    autoplaySpeed: 5000,
    dots: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: false,
          infinite: false,
          autoplay: false,
          slidesToShow: 1,
          variableWidth: true,
          adaptiveHeight: false,
        }
      },
    ]
  });
  $('#angebote-slider, #angebote-slider-b').slick({
    slidesToShow: 1,
    mobileFirst: true,
    autoplay: true,
    autoplaySpeed: 5000,
    dots: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: false,
          infinite: false,
          autoplay: false,
          slidesToShow: 1,
          variableWidth: true,
          adaptiveHeight: false,
        }
      },
    ]
  });
  
  
  $('#news-slider').slick({
    slidesToShow: 1,
    mobileFirst: true,
    autoplay: false,
    autoplaySpeed: 5000,
    dots: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: false,
          infinite: false,
          autoplay: false,
          slidesToShow: 1,
          variableWidth: true,
          adaptiveHeight: false,
        }
      },
    ]
  });
 
  $('#home-slider').on('init', function (event, slick) {

    $('#home-slider').addClass('imgvisible');

  });
  $('#menu-item-1005 a').on('click', function () {
    $('#off-canvas').foundation('close');
  });
  $('#home-slider').slick({
    autoplay: true,
    infinite: true,
    speed: 500,
    fade: true,
    autoplaySpeed: 5000,
    dots: true,
    arrows: false,
  });
  $(window).resize(function () {
    $('#news-slider').slick('refresh');
    $('#boxes-bar').slick('refresh');
    $('#home-slider').slick('refresh');
  });
  $('.grid').masonry({
    // options
    itemSelector: '.grid-item',
    columnWidth: '.grid-item',
    percentPosition: true
  });
  $('.grid-team').masonry({
    // options
    itemSelector: '.grid-item',
    columnWidth: '.grid-item',
    percentPosition: true
  });

  if (jQuery('.faecher-header .thumbnail-container').length != 0) {
    jQuery('.faecher-header').addClass('mit-thumbnail');
  }
});
// Select all links with hashes
$('a[href*="#"]')
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        event.preventDefault();
        
        // Berechne 3rem in Pixel, hier mit der Annahme von 16px für 1rem
        var offset = parseFloat(getComputedStyle(document.documentElement).fontSize) * 3;

        $('html, body').animate({
          scrollTop: target.offset().top - offset // 3rem Offset nach oben
        }, 1000, function() {
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) {
            return false;
          } else {
            $target.attr('tabindex','-1');
            $target.focus();
          };
        });
      }
    }
  });